import { render } from "./AnalyticsNotesStructureExportTable.vue?vue&type=template&id=4cd83b40&ts=true"
import script from "./AnalyticsNotesStructureExportTable.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesStructureExportTable.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__